export const SET_THEME_COLOR = "SET_THEME_COLOR"